import React from "react";

export default function ImageBrandHilite() {
  return (
    <div className="brand-link px-2 ">
      <a className="d-flex pr-4 " href={`${process.env.REACT_APP_DOMAIN}`}>
        <img src="/assets/img/icon-hilite-brand-sidebar.svg" />
      </a>
    </div>
  );
}
